export default function updateGuestsPage() {
    // create page header
    let sjContent = document.querySelector('#skilljar-content');

    let pageHeader = document.createElement('div');
    pageHeader.id = 'guest-header';
    pageHeader.innerHTML = `
        <h1>Guest Learning Page</h1>
        <h2>
            Welcome to ClickUp University! If you are a guest, this is where your journey begins!
        </h2>
    `;

    sjContent.prepend(pageHeader);
};
